<template>
  <div :id="id">
    <div class="date-picker-label">{{ label }}</div>
    <div class="date-time-picker-component" :style="frameStyle">
      <dropdownBtn
        :id="id + 'year'"
        class="date-year"
        v-model="dateYearValue"
        placeholder="請選擇"
        label="年"
        :disabled="disabled"
        :options="years"
        :errorText="errorText"
        @input="onYearInput"
      />

      <inputField
        :id="id + 'month'"
        class="date-month"
        :value="dateMonthValue"
        label="月"
        :disabled="true"
        v-if="isRecord"
      />
      <dropdownBtn
        :id="id + 'month'"
        class="date-month"
        v-model="dateMonthValue"
        placeholder="請選擇"
        label="月"
        :disabled="checkMonthDisable"
        :options="months"
        :errorText="errorText"
        @input="onMonthInput"
        v-else
      />

      <inputField
        :id="id + 'day'"
        class="date-day"
        :value="dateDayValue"
        label="日"
        :disabled="true"
        v-if="isRecord"
      />
      <dropdownBtn
        :id="id + 'day'"
        class="date-day"
        v-model="dateDayValue"
        placeholder="請選擇"
        label="日"
        :disabled="checkDayDisable"
        :options="days"
        :errorText="errorText"
        @input="onInput"
        v-else
      />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import { BFormInput } from 'bootstrap-vue';
import dropdownBtn from 'Components/dropdown/dropdown.vue';
import inputField from 'Components/inputField/inputField.vue';

Vue.component('b-form-input', BFormInput);

export default {
  name: 'DatePicker',
  components: {
    dropdownBtn,
    inputField
  },
  data() {
    return {
      dateYearValue: '',
      dateMonthValue: '',
      dateDayValue: '',
    };
  },
  props: {
    frameStyle: {
      type: Object,
      default: () => {},
    },
    labelStyle: {
      type: Object,
      default: () => {},
    },
    errorText: {
      type: String,
      default: '',
    },
    dateStyle: {
      type: Object,
      default: () => {},
    },
    id: {
      type: String,
      default: '',
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isRecord: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    valueDate() {
      return moment(this.value).format('YYYY-MM-DD');
    },
    valueYear() {
      return this.valueDate.split('-')[0] || '';
    },
    valueMonth() {
      return this.valueDate.split('-')[1] || '';
    },
    valueDay() {
      return this.valueDate.split('-')[2] || '';
    },
    // 今年往前推130年
    years() {
      const now = new Date();
      const endYear = now.getFullYear();
      const startYear = endYear - 130;

      const years = new Array(130).fill().map((_, k) => {
        const element = k + 1;
        const optionElement = `${element + startYear}`;
        return { text: optionElement, value: optionElement };
      });
      return years;
    },
    months() {
      const now = new Date();
      const nowYear = now.getFullYear();
      if (this.dateYearValue === `${nowYear}`) {
        // Date的getMonth是從0開始
        return new Array(now.getMonth() + 1).fill().map((_, k) => {
          const optionElement = this.padLeft(`${k + 1}`, 2);
          return { text: optionElement, value: optionElement };
        });
      }

      return new Array(12).fill().map((_, k) => {
        const optionElement = this.padLeft(`${k + 1}`, 2);
        return { text: optionElement, value: optionElement };
      });
    },
    days() {
      const year = Number(this.dateYearValue);
      const month = Number(this.dateMonthValue);
      var days = 31;

      const now = new Date();
      const nowYear = now.getFullYear();
      // Date的getMonth是從0開始
      const nowMonth = now.getMonth() + 1;
      // 當年當月
      if (year === nowYear && month === nowMonth) {
        days = now.getDate();
        //如果是2月
      } else if (month == 2) {
        //如果是閏年
        if ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0) {
          days = 29;
          //如果是平年
        } else {
          days = 28;
        }
        //如果是第4、6、9、11月
      } else if (month == 4 || month == 6 || month == 9 || month == 11) {
        days = 30;
      }

      return new Array(days).fill().map((_, k) => {
        const optionElement = this.padLeft(`${k + 1}`, 2);
        return { text: optionElement, value: optionElement };
      });
    },
    checkMonthDisable() {
      if (this.disabled || this.dateYearValue === '') {
        return true;
      } else {
        return false;
      }
    },
    checkDayDisable() {
      if (
        this.disabled ||
        this.dateYearValue === '' ||
        this.dateMonthValue === ''
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    onYearInput() {
      this.dateMonthValue = '';
      this.dateDayValue = '';
      this.onInput();
    },
    onMonthInput() {
      this.dateDayValue = '';
      this.onInput();
    },
    onInput() {
      if (
        this.dateYearValue !== '' &&
        this.dateMonthValue !== '' &&
        this.dateDayValue !== ''
      ) {
        const value = `${this.dateYearValue}/${this.dateMonthValue}/${this.dateDayValue}`;
        this.$emit('input', value);
      } else {
        this.$emit('input', '');
      }
    },
    /* 左邊補0 */
    padLeft(str, len) {
      str = '' + str;
      return str.length >= len
        ? str
        : new Array(len - str.length + 1).join('0') + str;
    },
  },
  created() {
    if (this.value) {
      this.dateYearValue = this.valueYear;
      this.dateMonthValue = this.isRecord ? '**' : this.valueMonth;
      this.dateDayValue = this.isRecord ? '**' : this.valueDay;
    }
  },
};
</script>

<style scoped>
.date-time-picker-component {
  display: flex;
  justify-content: space-around;
}
.date-year {
  width: 33%;
}
.date-month {
  width: 33%;
  margin-left: 10px;
}
.date-day {
  width: 33%;
  margin-left: 10px;
}
.date-year,
.date-month,
.date-day {
  margin-top: 20px;
}
.date-picker-label {
  text-align: center;
  color: #b18147;
  font-size: 12px;
  font-weight: bold;
  background-color: #ffffff;
  z-index: 2;
  padding: 0px 3px 0px 3px;
  height: 20px;
  position: absolute;
}
</style>
